var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoDropbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_98_660)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.19961 1.15642L0.286872 6.95847C-0.0773714 7.19564 -0.0974251 7.60751 0.242008 7.87855L6.68481 13.0253L16.9999 6.67804L10.4634 1.23078C10.1295 0.952666 9.56385 0.919629 9.19961 1.15642Z",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5979 26.1169L17.0417 20.689V20.6465L17.0209 20.6678L17.0001 20.6465V20.689L10.4644 26.1158C10.1301 26.3935 9.56438 26.4257 9.20052 26.1882L6.79004 24.6136V26.082C6.79004 26.5167 7.09213 27.0497 7.46505 27.273C7.46505 27.273 17.0004 32.9913 17.0004 32.9973C17.0004 33.0032 17.0051 33.0032 17.011 32.9973C17.0169 32.9913 17.0259 32.9913 17.0318 32.9973C17.0378 33.0032 17.0425 33.0032 17.0425 32.9973C17.0425 32.9913 26.5984 27.2723 26.5984 27.2723C26.9713 27.0492 27.2738 26.5163 27.2738 26.082V24.6136L24.8633 26.1882C24.4987 26.4257 23.9322 26.3939 23.5979 26.1169Z",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.286814 19.1132L9.19917 24.9153C9.56341 25.1524 10.1291 25.119 10.4631 24.8409L16.9999 19.3936L6.6852 13.0251L0.241565 18.1919C-0.0975465 18.4638 -0.077043 18.8764 0.286814 19.1132Z",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7135 6.95797L24.8208 1.15714C24.4569 0.919581 23.8909 0.952232 23.557 1.2299L17 6.67792L27.3147 13.0251L33.7575 7.87844C34.0971 7.60746 34.0773 7.1952 33.7135 6.95797Z",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7581 18.1919L27.3144 13.0251L17.6693 18.9802C17.2995 19.2083 17.2709 19.6186 17.6052 19.8963L23.5568 24.8416C23.8911 25.1193 24.4567 25.1519 24.8206 24.9144L33.7132 19.1139C34.0771 18.8764 34.0972 18.4638 33.7581 18.1919Z",
    fill: "#383838"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_98_660"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 33.9999,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDropbox);
export default __webpack_public_path__ + "static/media/logo-dropbox.263cda3c31a98a96f1d8d66b18186540.svg";
export { ForwardRef as ReactComponent };